// ====================== PC端时间线交互 ======================
document.addEventListener("DOMContentLoaded", () => {
  const initTimelineSlider = () => {
    const containers = document.querySelectorAll("[data-timeline-slider]");

    containers.forEach((container) => {
      // 这里的 wrapper 才是真正产生 overflow 和 scroll 的容器
      const wrapper = container.querySelector(".timeline-wrapper");
      const prevBtn = container.querySelector(".slider-button--prev");
      const nextBtn = container.querySelector(".slider-button--next");

      if (!wrapper || !prevBtn || !nextBtn) return;

      // 1. 动态获取单次滑动步长（一个卡片的实际宽度）
      const getScrollStep = () => {
        const firstCard = wrapper.querySelector(".timeline-card");
        // 如果能获取到卡片就用真实宽度(316px+padding)，否则给个保底值
        return firstCard ? firstCard.offsetWidth : 316; 
      };

      // 2. 检测滚动边界，到顶/到底时添加 is-disabled 隐藏按钮
      const updateButtonStates = () => {
        const scrollLeft = wrapper.scrollLeft;
        const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;

        // 预留 2px 误差值，防止浏览器缩放或浮点数导致无法完美触达边界
        const isAtStart = scrollLeft <= 2;
        const isAtEnd = scrollLeft >= maxScroll - 2;

        if (isAtStart) {
          prevBtn.classList.add("is-disabled");
          prevBtn.classList.remove("is-active-hover");
        } else {
          prevBtn.classList.remove("is-disabled");
        }

        if (isAtEnd) {
          nextBtn.classList.add("is-disabled");
          nextBtn.classList.remove("is-active-hover");
        } else {
          nextBtn.classList.remove("is-disabled");
        }
      };

      // 3. 鼠标在整个外部容器移动时，感应左右半区
      container.addEventListener("mousemove", (e) => {
        // 移动端无需此交互
        if (window.innerWidth < 750) return;

        const rect = container.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const isLeftHalf = mouseX < rect.width / 2;

        const isPrevDisabled = prevBtn.classList.contains("is-disabled");
        const isNextDisabled = nextBtn.classList.contains("is-disabled");

        // 在左半区：高亮左按钮（前提是没到最左边），恢复右按钮
        if (isLeftHalf) {
          if (!isPrevDisabled) prevBtn.classList.add("is-active-hover");
          nextBtn.classList.remove("is-active-hover");
        } else {
        // 在右半区：高亮右按钮（前提是没到最右边），恢复左按钮
          if (!isNextDisabled) nextBtn.classList.add("is-active-hover");
          prevBtn.classList.remove("is-active-hover");
        }
      });

      // 4. 鼠标离开容器区域，清除高亮感应
      container.addEventListener("mouseleave", () => {
        prevBtn.classList.remove("is-active-hover");
        nextBtn.classList.remove("is-active-hover");
      });

      // 5. 点击按钮，执行单卡片流畅滚动
      // 浏览器原生的 smooth scrollBy 会自动处理剩余宽度不够一张卡片的情况，不会溢出
      prevBtn.addEventListener("click", () => {
        wrapper.scrollBy({ left: -getScrollStep(), behavior: "smooth" });
      });

      nextBtn.addEventListener("click", () => {
        wrapper.scrollBy({ left: getScrollStep(), behavior: "smooth" });
      });

      // 6. 监听 wrapper 的原生滚动事件，实时刷新按钮状态
      wrapper.addEventListener("scroll", updateButtonStates, { passive: true });
      
      // 7. 窗口尺寸变化时重新计算边界
      window.addEventListener("resize", updateButtonStates);

      // 初始化立刻执行一次边界判断
      updateButtonStates();
    });
  };

  initTimelineSlider();

  // 兼容 Shopify 主题编辑器
  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", initTimelineSlider);
  }
});

// ====================== 移动端时间线交互 ======================
document.addEventListener("DOMContentLoaded", () => {
  // 移动端折叠/展开
  const mobileWrapper = document.querySelector(".timeline-container-mobile");
  if (!mobileWrapper) return;

  const mobileItems = mobileWrapper.querySelectorAll("[data-mobile-item]");
  const loadMoreBtn = mobileWrapper.querySelector("[data-loadmore]");
  const hiddenItems = mobileWrapper.querySelectorAll(".timeline-item-hidden");
  // 默认收起的高度（和你写的一致：1行文字高度）
  const DEFAULT_LINE_HEIGHT = 'calc(12px * 1.5 * 1)';
  // 动画时长（统一管理）
  const ANIMATION_DURATION = '0.6s cubic-bezier(.22,1,.36,1)';

  // ====================== 点击展开逻辑 ======================
  const handleExpand = (desc) => {
    // 取消文本省略限制
    desc.style.webkitLineClamp = 'unset';
    desc.style.overflow = 'visible';
    desc.style.display = 'block';

    // 计算文本真实高度
    desc.style.height = 'auto';
    const fullHeight = desc.offsetHeight;
    // 先重置为默认单行高度
    desc.style.height = DEFAULT_LINE_HEIGHT;

    desc.clientHeight; // 强制浏览器重绘，触发动画

    // 执行展开动画
    desc.style.transition = ANIMATION_DURATION;
    desc.style.height = fullHeight + 'px';
  };

  // ====================== 点击收起逻辑 ======================
  const handleCollapse = (desc) => {
    // 执行收起动画
    desc.style.transition = ANIMATION_DURATION;
    desc.style.height = DEFAULT_LINE_HEIGHT;

    // 动画结束后，恢复文本省略样式（时间和动画时长一致）
    setTimeout(() => {
      desc.style.webkitLineClamp = '1'; // 恢复1行省略
      desc.style.overflow = 'hidden';
      desc.style.display = '-webkit-box';
      desc.style.webkitBoxOrient = 'vertical';
    }, 600); // 对应0.6s动画
  };

  // ====================== 点击切换展开/关闭 ======================
  mobileItems.forEach((item) => {
    item.addEventListener("click", () => {
      const desc = item.querySelector(".timeline-mobile-desc .timeline-mobile-desc-content");
      if (!desc) return;

      // 核心：判断当前状态 → 展开/收起二选一
      if (item.classList.contains("active")) {
        // 已有active：执行收起
        handleCollapse(desc);
      } else {
        // 无active：执行展开
        handleExpand(desc);
      }

      // 切换激活状态类
      item.classList.toggle("active");
    });
  });

  // ====================== 加载更多【展开/收缩切换】逻辑 ======================
  if (loadMoreBtn && hiddenItems.length > 0) {
    loadMoreBtn.addEventListener("click", () => {
      hiddenItems.forEach((item) => {
        item.classList.toggle("show");
      });
      loadMoreBtn.classList.toggle("rotate");
    });
  }
});
